import { useEffect, useRef, useState } from "react";

import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { CircleAlert, Plus } from "lucide-react";

import { useAppSelector } from "store/store";

import ImageUrl from "components/app/image-url/ImageUrl";

import DailogEditImageCategories from "./dialog/DailogEditImageCategories";
import "./ProductService.css";

import UploadProductServicePotoGroup from "components/app/upload-profile/UploadProductServicePotoGroup";
import { Sheet, SheetContent } from "components/ui/sheet";

import DailogEditAndAddCategoriesGroup from "./dialog/DailogEditAndAddCategoriesGroup";

import { ShimmerCategoriesRender } from "components/app/shrimmer/Shrimmer";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";

import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import PageEditProducts from "./dialog/PageEditProducts";
import DialogUploadProduct from "./dialog/DialogUploadProduct";

import ProductAction from "./ProductAction";
import ProductServiceTable from "./ProductServiceTable";
import ProductServiceCard from "./ProductServiceCard";
import ProductServicseNavbarAction from "./ProductServicseNavbarAction";
import { useLocation } from "react-router-dom";
import useUrlString from "./useUrlString";
export default function ProductService() {
  const { handleClickUrl, hanleClickRemoveURl } = useUrlString();
  const dataProducts: any = ProductAction();
  const { btnSearchProduct, btnToggleProduct } = useAppSelector((state) => state.header);
  const [view, setView] = useState("card");
  const [defaultDataCategories, setDefaultDataCategories] = useState<boolean>(false);
  const [isDialogOpenEditCategoies, setIsDialogOpenEditCategoies] = useState<boolean>(false);
  const [isDialogOpenEditProducts, setIsDialogOpenEditProducts] = useState<boolean>(false);
  const [editItemCategories, setEditItemCategories] = useState<any>(null);
  const [editItemImageCategories, setEditItemImageCategories] = useState<any>({});
  const [isApiEditAndAddProduct, setIsApiEditAndAddProduct] = useState<boolean>(false);
  const [isDialogEditImageOpen, setIsDialogEditImageOpen] = useState<boolean>(false);
  const [hovered, setHovered] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<any>(null);
  useEffect(() => {
    if (listRef.current && dataProducts?.productLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      dataProducts?.fetchMoreUserShopProduct({
        next: dataProducts?.productLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProducts?.productDatas?.data]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", dataProducts?.handleScroll);
    }
    return () => {
      if (container) container.removeEventListener("scroll", dataProducts?.handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dataProducts?.initUserShopProduct();
    const savedView = localStorage.getItem("productView");
    if (savedView) {
      setView(savedView);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProducts?.searchTextInput, dataProducts?.selectedProductGroupCode, btnToggleProduct, btnSearchProduct]);
  // useEffect initCategories
  useEffect(() => {
    dataProducts?.initCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //view card or table products
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("productView", selectedView);
  };
  const { indexProductservicse } = useAppSelector((state) => state.header);
  const allIds = Array.isArray(dataProducts?.productDatas?.data) ? dataProducts?.productDatas?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => dataProducts?.selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      dataProducts?.setSelectedProductIds([]);
    } else {
      // Select all
      dataProducts?.setSelectedProductIds(allIds);
    }
  };
  // const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
  const [isDailogUploadProducts, setIsDailogUploadProducts] = useState<boolean>(false);
  const location = useLocation();
  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("product_id");
    if (requestId) {
      (async () => {
        dataProducts?.setOpenPopoverIndex(1);
        dataProducts?.getShopProductDetail(requestId);
        dataProducts?.setDefaultDataProduct(true);
        dataProducts?.setId(requestId);
      })();
    }
  }, []);

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="lg:w-auto md:w-auto w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm ">Product & Services</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Seamless Setup for Maximum Marketplace Visibility</p>
          </div>
          {dataProducts?.warning ? (
            ""
          ) : (
            <ProductServicseNavbarAction
              selectProducts={dataProducts?.selectProducts}
              selectedProductIds={dataProducts?.selectedProductIds}
              allIds={allIds}
              setOpenPopoverIndex={dataProducts?.setOpenPopoverIndex}
              setEditItemShopProduct={dataProducts?.setEditItemShopProduct}
              setIsApiEditAndAddProduct={setIsApiEditAndAddProduct}
              selectedProductGroupCode={dataProducts?.selectedProductGroupCode}
              itemGroups={dataProducts?.itemGroups}
              setId={dataProducts?.setId}
              setIsDialogOpenEditCategoies={setIsDialogOpenEditCategoies}
              onSubmitDeleteProdcuts={dataProducts?.onSubmitDeleteProdcuts}
              submitUndoDeleteShopProduct={dataProducts?.submitUndoDeleteShopProduct}
              setSelectProducts={dataProducts?.setSelectProducts}
              isAllSelected={isAllSelected}
              handleToggleSelectAll={handleToggleSelectAll}
              setSelectedProductIds={dataProducts?.setSelectedProductIds}
              handlePrint={dataProducts?.handlePrint}
              loadingPrint={dataProducts?.loadingPrint}
              setSearchTextInput={dataProducts?.setSearchTextInput}
              view={view}
              changeView={changeView}
            />
          )}
        </div>
        {dataProducts?.warning ? (
          ""
        ) : (
          <div
            ref={containerRef}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
          >
            {/* Hover Overflow Scroll Container */}
            <div className="relative w-full ">
              <div className="flex space-x-2 w-full">
                <HoverCardDetail
                  title="Add New Group"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm text-gray-800">
                        Create a new group to organize related products or services. Groups are useful for keeping your catalog structured and easy to manage.
                      </p>
                      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                        <li>Use groups to categorize items by type, department, or usage.</li>
                        <li>Helps improve search, filtering, and bulk operations.</li>
                        <li>Essential for applying shared settings or pricing rules.</li>
                        <li>Groups appear in reports and dashboards for better insights.</li>
                      </ul>
                    </>
                  }
                >
                  <label
                    onClick={() => {
                      setIsDialogOpenEditCategoies(true);
                      setDefaultDataCategories(true);
                      setEditItemCategories(null);
                      dataProducts?.setSelectedProductGroupCode("All");
                      dataProducts?.handleClickCategory({
                        categoryName: "All",
                        groupId: "",
                      });
                    }}
                    className="font-semibold rounded-md  lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 ld:p-3 p-2  flex items-center justify-center cursor-pointer text-md border "
                  >
                    <Plus className="font-semibold text-xl" />
                  </label>
                </HoverCardDetail>

                <div
                  onClick={() => {
                    if (dataProducts?.selectedProductGroupCode === "All") {
                      setEditItemCategories("");
                      if (dataProducts?.itemGroups?.data?.length) {
                        dataProducts?.setId(dataProducts?.itemGroups.data[0].product_group_id);
                      }
                    }
                    dataProducts?.handleClickCategory({
                      categoryName: "All",
                      groupId: "",
                    });
                  }}
                  className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                    dataProducts?.selectedProductGroupCode === "All" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
                  }`}
                >
                  <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                </div>
                {/* Product Categories */}
                <div className="space-x-2 flex">
                  {dataProducts?.loadingFetchDataCategoires ? (
                    <>
                      <ShimmerCategoriesRender />
                    </>
                  ) : (
                    <>
                      {dataProducts?.itemGroups?.data?.map((group: any) => (
                        <div key={group.id} className="flex items-center">
                          <div
                            className={`w-[200px] border rounded-md cursor-pointer font-semibold 
                                ${
                                  dataProducts?.selectedProductGroupCode === (group?.local_description ? group.local_description.toString() : "")
                                    ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200"
                                    : "dark:hover:bg-slate-900"
                                }`}
                            onClick={() => {
                              setEditItemCategories(group);
                              setDefaultDataCategories(false);
                              dataProducts?.setId(group.product_group_id);
                              dataProducts?.handleClickCategory({
                                categoryName: group?.local_description ?? "", // Ensure it's a string or fallback to ""
                                groupId: group?.product_group_id,
                              });
                            }}
                          >
                            <div className="flex group">
                              <div className="flex relative lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10">
                                {/* Image */}
                                <div className="lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10">
                                  <ImageUrl className="rounded-md flex-shrink-0 object-cover w-full h-full" src={group?.thumbnail} alt="" />
                                </div>
                                <div className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
                                  <UploadProductServicePotoGroup
                                    itemGroups={group}
                                    onUploadSuccess={({ res, name }) => {
                                      dataProducts?.setItemGroups((prevItemGroups: any) => {
                                        const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                                        const exists = updatedData.some((item: any) => item.id === res.id);
                                        if (!exists) {
                                          updatedData.push(res);
                                        }
                                        return {
                                          ...prevItemGroups,
                                          data: updatedData,
                                        };
                                      });
                                    }}
                                  />
                                </div>
                                {/* Hover Overlay */}
                              </div>

                              <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden  flex items-center justify-center">
                                {group?.local_description ?? "No Description"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {dataProducts?.warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              dataProducts?.errorStatus?.title === "success" || dataProducts?.errorStatus?.title === "info"
                ? "text-green-500"
                : dataProducts?.errorStatus?.title === "warning"
                ? "text-yellow-500"
                : "text-red-500"
            }`}
          >
            {dataProducts?.errorStatus?.title === "success"
              ? "Success"
              : dataProducts?.errorStatus?.title === "info"
              ? "Infomation"
              : dataProducts?.errorStatus?.title === "warning"
              ? "Warning"
              : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{dataProducts?.errorStatus?.message}</span>
        </div>
      ) : (
        <div className="pb-3 h-full mt-5  ">
          {view === "card" ? (
            <>
              <ProductServiceCard
                handleClickUrl={handleClickUrl}
                listRef={listRef}
                productDatas={dataProducts?.productDatas}
                productLoading={dataProducts?.productLoading}
                loadingFetchDataProducts={dataProducts?.loadingFetchDataProducts}
                fetchMoreUserShopProduct={dataProducts?.fetchMoreUserShopProduct}
                setDefaultDataProduct={dataProducts?.setDefaultDataProduct}
                getShopProductDetail={dataProducts?.getShopProductDetail}
                setOpenPopoverIndex={dataProducts?.setOpenPopoverIndex}
                setId={dataProducts?.setId}
                selectProducts={dataProducts?.selectProducts}
                setSelectedProductIds={dataProducts?.setSelectedProductIds}
                selectedProductIds={dataProducts?.selectedProductIds}
                setProductDatas={dataProducts?.setProductDatas}
                indexProductservicse={indexProductservicse}
              />
            </>
          ) : (
            // list Table
            <>
              <ProductServiceTable
                handleClickUrl={handleClickUrl}
                listRef={listRef}
                productDatas={dataProducts?.productDatas}
                productLoading={dataProducts?.productLoading}
                loadingFetchDataProducts={dataProducts?.loadingFetchDataProducts}
                fetchMoreUserShopProduct={dataProducts?.fetchMoreUserShopProduct}
                setDefaultDataProduct={dataProducts?.setDefaultDataProduct}
                getShopProductDetail={dataProducts?.getShopProductDetail}
                setOpenPopoverIndex={dataProducts?.setOpenPopoverIndex}
                setId={dataProducts?.setId}
                selectProducts={dataProducts?.selectProducts}
                setSelectedProductIds={dataProducts?.setSelectedProductIds}
                selectedProductIds={dataProducts?.selectedProductIds}
                setProductDatas={dataProducts?.setProductDatas}
              />
            </>
          )}
        </div>
      )}

      <DailogEditAndAddCategoriesGroup
        onUploadSuccess={({ res, name }) => {
          if (name === "delete") {
            dataProducts?.setItemGroups((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => item.id !== res.id),
              };
            });
            // setSelectedProductGroupCode("All");
            dataProducts?.handleClickCategory({
              categoryName: "All",
              groupId: "",
            });
          } else {
            dataProducts?.setItemGroups((prevItemGroups: any) => {
              const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
              const exists = updatedData.some((item: any) => item.id === res.id);
              if (!exists) {
                updatedData.push(res);
              }
              return {
                ...prevItemGroups,
                data: updatedData,
              };
            });
          }
        }}
        editItemCategories={editItemCategories}
        setEditItemCategories={setEditItemCategories}
        isDialogOpenEditCategoies={isDialogOpenEditCategoies}
        setIsDialogOpenEditCategoies={setIsDialogOpenEditCategoies}
        defaultDataCategories={defaultDataCategories}
        itemPrinter={dataProducts?.itemPrinter}
        setItemPrinter={dataProducts?.setItemPrinter}
      />
      {/* dia log edit image categories group */}

      <DailogEditImageCategories
        editItemImageCategories={editItemImageCategories}
        isDialogEditImageOpen={isDialogEditImageOpen}
        setIsDialogEditImageOpen={setIsDialogEditImageOpen}
      />
      {/* dia log add products group */}

      <BtnGoToTop />

      <Sheet
        open={dataProducts?.openPopoverIndex === 1}
        onOpenChange={(isOpen) => {
          dataProducts?.setOpenPopoverIndex(isOpen ? 1 : null);
          setIsApiEditAndAddProduct(false);
          if (!isOpen) {
            hanleClickRemoveURl("product_id");
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1000px] justify-between p-3 pt-[50px]">
          <PageEditProducts
            onUploadSuccess={({ res, name }) => {
              if (name === "delete") {
                dataProducts?.setProductDatas((prevItemGroups: any) => {
                  return {
                    ...prevItemGroups,
                    data: (prevItemGroups.data || []).filter((item: any) => item.id !== res.id),
                  };
                });
              } else {
                dataProducts?.setProductDatas((prevItemGroups: any) => {
                  const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                  const exists = updatedData.some((item: any) => item.id === res.id);
                  if (!exists) {
                    updatedData.push(res);
                  }
                  return {
                    ...prevItemGroups,
                    data: updatedData,
                  };
                });
              }
            }}
            setIsDailogUploadProducts={setIsDailogUploadProducts}
            setOpenPopoverIndex={dataProducts?.setOpenPopoverIndex}
            setProductDatas={dataProducts?.setProductDatas}
            editItemCategories={editItemCategories}
            editItemShopProduct={dataProducts?.editItemShopProduct}
            setEditItemShopProduct={dataProducts?.setEditItemShopProduct}
            isDialogOpenEditProducts={isDialogOpenEditProducts}
            setIsDialogOpenEditProducts={setIsDialogOpenEditProducts}
            isApiEditAndAddProduct={isApiEditAndAddProduct}
            setIsApiEditAndAddProduct={setIsApiEditAndAddProduct}
            itemGroups={dataProducts?.itemGroups}
            id={dataProducts?.id}
            setId={dataProducts?.setId}
            defaultDataProduct={dataProducts?.defaultDataProduct}
            loadingFetchDataProductDetail={dataProducts?.loadingFetchDataProductDetail}
          />
        </SheetContent>
      </Sheet>
      <DialogUploadProduct
        setProductDatas={dataProducts?.setProductDatas}
        editItemCategories={editItemCategories}
        itemGroups={dataProducts?.itemGroups}
        isDailogUploadProducts={isDailogUploadProducts}
        setIsDailogUploadProducts={setIsDailogUploadProducts}
        setIsDialogOpenEditProducts={setIsDialogOpenEditProducts}
      />
    </BusinessSuiteContentLayout>
  );
}
